import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ISiteSettings } from '@sravni/types/lib/sitesettings';

import { APP_PAGES_NAMES } from 'constants/routes';

import type { StateSiteSettings } from '../types';

const initialState: StateSiteSettings = {
  footer: undefined,
  header: undefined,
  appPageName: APP_PAGES_NAMES.UNDEFINED_PAGE,
  isMarketplaceEnabled: false,
};

export const siteSettingsSlice = createSlice({
  name: 'siteSettings',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<ISiteSettings>) => {
      state.header = action.payload.header;
      state.footer = action.payload.footer;
    },
    setAppPageName: (state, action: PayloadAction<ValuesOf<typeof APP_PAGES_NAMES>>) => {
      state.appPageName = action.payload;
    },
    setIsMarketplaceEnabled: (state, action: PayloadAction<boolean>) => {
      state.isMarketplaceEnabled = action.payload;
    },
  },
});

export const { setSettings, setAppPageName, setIsMarketplaceEnabled } = siteSettingsSlice.actions;
